import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { CaixaBanco } from '@pgcustom/shared-types';

/**
 * Adapter do módulo Caixa Banco — único ponto que conhece
 * `GET /api/v1/caixa-banco` (`caixa-banco.routes.ts`). Devolve
 * `Resultado<CaixaBanco>` para a tela tratar os estados direto.
 */
export class CaixaBancoApi {
  constructor(private readonly api: ApiClient) {}

  async obter(): Promise<Resultado<CaixaBanco>> {
    try {
      const dado = await this.api.get<CaixaBanco>('/caixa-banco');
      return { status: 'ok', dado };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return {
        status: 'erro',
        mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar o Caixa Banco',
      };
    }
  }
}
